const { getOffsetTop } = window.BAO.Utils

class YotpoStars extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setStars()
  }

  setupListeners () {
    super.setupListeners()
  }

  async setStars () {
    const productId = this.dataset.id

    const minReviews = parseInt(window.yotpoStrings.minReviews)
    try {
      const response = await fetch(
        `https://api-cdn.yotpo.com/v1/widget/${window.yotpoStrings.apiKey}/products/${productId}/reviews.json`,
      )

      if (response.ok) {
        const reviews = await response.json()

        const totalReviews = reviews.response.bottomline.total_review
        const averageScore = reviews.response.bottomline.average_score
        const roundedScore = averageScore.toFixed(1)

        if (totalReviews < minReviews) {
          this.setAttribute('aria-hidden', 'true')
        } else {
          this.setAttribute('aria-hidden', 'false')
        }

        const offset = 3 * parseInt(averageScore)
        let barWidth = (53 * averageScore) / 5 + offset

        if (averageScore < 1) {
          barWidth = (65 * averageScore) / 5
        }

        this.els.bar.element.style.width = barWidth

        if (this.els?.reviews?.element) {
          this.els.reviews.element.innerHTML = `(${totalReviews})`
        }

        if (this.els['full-reviews']?.element) {
          this.els[
            'full-reviews'
          ].element.innerHTML = `/ ${totalReviews} review${
            totalReviews > 1 ? 's' : ''
          }`
        }

        if (this.els?.score?.element) {
          this.els.score.element.innerHTML = `${roundedScore}`
        }
      }
    } catch (error) {
      console.error('Fetch error:', error)
    }
  }
}

if (!customElements.get('yotpo-stars')) {
  customElements.define('yotpo-stars', YotpoStars)
}

class YotpoReviews extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.fetchReviews()

    this.observeForTriggerElements()
  }

  observeForTriggerElements () {
    const observer = new MutationObserver((mutationsList, observer) => {
      if (this.els?.trigger?.elements) {
        this.els.trigger.elements.forEach(triggerEl => {
          this.listeners.add(triggerEl, 'click', this.handleTrigger.bind(this))
        })
        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)
    this.handleScroll = this.handleScroll.bind(this)

    this.els.close?.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    if (this.externalEls?.stars?.element) {
      this.listeners.add(
        this.externalEls.stars.element,
        'click',
        this.handleScroll,
      )
    }
  }

  async fetchAllReviews (productId) {
    const allReviews = []
    let page = 1
    const pageLimit = 5

    while (true) {
      const response = await fetch(
        `https://api-cdn.yotpo.com/v1/widget/${window.yotpoStrings.apiKey}/products/${productId}/reviews.json?page=${page}&per_page=${pageLimit}`,
      )
      const data = await response.json()

      if (
        data.response.reviews &&
        data.response.reviews.length > 0 &&
        page < 5
      ) {
        allReviews.push(...data.response.reviews)
        page++
      } else {
        break
      }
    }

    return allReviews
  }

  async fetchReviews () {
    const productId = this.dataset.id
    const allReviews = await this.fetchAllReviews(productId)

    if (allReviews.length > 0) {
      this.getMedia(allReviews)
      this.getReviews(allReviews)
    } else {
      this.setAttribute('aria-hidden', 'true')
    }
  }

  async getMedia (reviewsData) {
    if (!Array.isArray(reviewsData)) return

    const reviewImages = reviewsData
      .flatMap(review => review.images_data)
      .filter(image => image !== null)

    this.els.gallery.element.setAttribute(
      'aria-hidden',
      reviewImages.length === 0,
    )

    let htmlContent = ''
    reviewImages.forEach(imageData => {
      htmlContent += `<div class="prd-Reviews_ImageContainer" data-yotpo-reviews-el="trigger" data-image="${imageData.original_url}"><img src="${imageData.thumb_url}" alt="Review Image" class="prd-Reviews_Image" /></div>`
    })

    this.els.slider.element.innerHTML = htmlContent
  }

  async getReviews (reviewsData) {
    let reviewsSlides = ''

    reviewsData.forEach((reviewEl, index) => {
      const reviewIndex = (index + 1).toString().padStart(2, '0')
      const totalReviews = reviewsData.length.toString().padStart(2, '0')

      const reviewSlide = this.getReviewSlide(
        reviewEl,
        reviewIndex,
        totalReviews,
      )

      reviewsSlides += reviewSlide
    })

    this.els.slides.element.innerHTML = reviewsSlides

    this.carousel = this.initialiseCarousel.bind(this)
    this.carousel()
  }

  getReviewSlide (reviewEl, index, totalReviews) {
    const barWidth = this.getStars(reviewEl)

    return `<div class="prd-Reviews_Slide keen-slider__slide" data-yotpo-reviews-el="slide">
      <div class="prd-Reviews_SlideStars">
      <svg width="65" height="15" viewBox="0 0 65 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="stars-${reviewEl.id}">
        <path d="M5.25731 2L6.49839 5.81966H10.5146L7.26543 8.18034L8.50651 12L5.25731 9.63932L2.00811 12L3.2492 8.18034L0 5.81966H4.01623L5.25731 2Z" fill="#ffffff"/>
        <path d="M18.772 2L20.013 5.81966H24.0293L20.7801 8.18034L22.0212 12L18.772 9.63932L15.5228 12L16.7638 8.18034L13.5146 5.81966H17.5309L18.772 2Z" fill="#ffffff"/>
        <path d="M32.2866 2L33.5277 5.81966H37.5439L34.2947 8.18034L35.5358 12L32.2866 9.63932L29.0374 12L30.2785 8.18034L27.0293 5.81966H31.0455L32.2866 2Z" fill="#ffffff"/>
        <path d="M45.8013 2L47.0423 5.81966H51.0586L47.8094 8.18034L49.0505 12L45.8013 9.63932L42.5521 12L43.7931 8.18034L40.5439 5.81966H44.5602L45.8013 2Z" fill="#ffffff"/>
        <path d="M59.3159 2L60.557 5.81966H64.5732L61.324 8.18034L62.5651 12L59.3159 9.63932L56.0667 12L57.3078 8.18034L54.0586 5.81966H58.0748L59.3159 2Z" fill="#ffffff"/>
      </mask>
      <rect height="15" width="${barWidth}" fill="#333333" mask="url(#stars-${
      reviewEl.id
    })"></rect>
    </svg>
    <svg
      class="prd-Reviews_StarsOutline"
      width="65"
      height="15"
      viewBox="0 0 65 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.25731 2L6.49839 5.81966H10.5146L7.26543 8.18034L8.50651 12L5.25731 9.63932L2.00811 12L3.2492 8.18034L0 5.81966H4.01623L5.25731 2Z" fill="#333333"/>
        <path d="M18.772 2L20.013 5.81966H24.0293L20.7801 8.18034L22.0212 12L18.772 9.63932L15.5228 12L16.7638 8.18034L13.5146 5.81966H17.5309L18.772 2Z" fill="#333333"/>
        <path d="M32.2866 2L33.5277 5.81966H37.5439L34.2947 8.18034L35.5358 12L32.2866 9.63932L29.0374 12L30.2785 8.18034L27.0293 5.81966H31.0455L32.2866 2Z" fill="#333333"/>
        <path d="M45.8013 2L47.0423 5.81966H51.0586L47.8094 8.18034L49.0505 12L45.8013 9.63932L42.5521 12L43.7931 8.18034L40.5439 5.81966H44.5602L45.8013 2Z" fill="#333333"/>
        <path d="M59.3159 2L60.557 5.81966H64.5732L61.324 8.18034L62.5651 12L59.3159 9.63932L56.0667 12L57.3078 8.18034L54.0586 5.81966H58.0748L59.3159 2Z" fill="#333333"/>
    </svg>
      </div>
      <h5 class="prd-Reviews_SlideTitle fz-12_150">${reviewEl.title}</h5>
      <div class="prd-Reviews_SlideText fz-10_150">${reviewEl.content}</div>
      ${
        reviewEl.comment
          ? `<div class="prd-Reviews_Comment"><h6 class="fz-12_150">${window.yotpoStrings.responseTitle}</h6><div class="prd-Reviews_Response fz-10_150">${reviewEl.comment.content}</div></div>`
          : ''
      }
      <p class="prd-Reviews_Profile fz-12_150">${reviewEl.user.display_name}</p>
      ${
        reviewEl.images_data && reviewEl.images_data.length > 0
          ? reviewEl.images_data
              .map(
                image =>
                  `<div data-yotpo-reviews-el="trigger" data-image="${image.original_url}"><img src="${image.thumb_url}" alt="${reviewEl.title}" class="prd-Reviews_SlideImage"></div>`,
              )
              .join('')
          : ''
      }
      <div class="prd-Reviews_CustomFields fz-10_150">
        ${
          reviewEl.custom_fields['--99891']
            ? `<p>${window.yotpoStrings.heightTitle} ${reviewEl.custom_fields['--99891'].value}</p>`
            : ''
        }
        ${
          reviewEl.custom_fields['--99893']
            ? `<p>${window.yotpoStrings.purchasedTitle} (${reviewEl.custom_fields['--99893'].value})</p>`
            : ''
        }
        ${
          reviewEl.custom_fields['--99894']
            ? `<p>${window.yotpoStrings.sizeTitle} (${reviewEl.custom_fields['--99894'].value})</p>`
            : ''
        }
      </div>
      <span class="prd-Reviews_Pagination fz-10_150">${index}/${totalReviews}</span>
    </div>`
  }

  getStars (reviewEl) {
    const score = reviewEl.score

    const offset = 3 * score
    let barWidth = (53 * score) / 5 + offset

    if (score < 1) {
      barWidth = (65 * score) / 5
    }

    return barWidth
  }

  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: this.els.slides.element.dataset.slides,
              spacing: this.els.slides.element.dataset.gap,
            },
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  handleTrigger (e) {
    this.els.modal.element.setAttribute('aria-hidden', 'false')
    document.body.classList.toggle('util-SiteOverflowed', true)

    this.els['modal-body'].element.innerHTML = `<img src="${
      e.target.closest(this.els.trigger.selector).dataset.image
    }" class="prd-Reviews_ModalImage" />`
  }

  handleClose () {
    this.els.modal.element.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  handleScroll () {
    window.scrollTo({
      top: getOffsetTop(this) - 100,
      left: 0,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('yotpo-reviews')) {
  customElements.define('yotpo-reviews', YotpoReviews)
}
